import { render } from "./TransportDhl.vue?vue&type=template&id=0c1f5a50"
import script from "./TransportDhl.vue?vue&type=script&lang=js"
export * from "./TransportDhl.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__